












import { defineComponent, ref, computed } from '@nuxtjs/composition-api';
import { useTranslations } from '@vue-storefront/novulo';

const PLP_BANNER_TYPES = {
  ImageCta: 'image-cta',
  Usps: 'usps'
};

export default defineComponent({
  name: 'PLPCareplanBanner',
  props: {
    position: {
      type: Number,
      required: true,
      default: 0
    }
  },
  setup(props) {
    const { translate } = useTranslations();
    const IMAGE_BANNERS_COUNT = 1;

    const bannerType = ref(
      props.position <= IMAGE_BANNERS_COUNT
        ? PLP_BANNER_TYPES.ImageCta
        : PLP_BANNER_TYPES.Usps
    );

    const usps = computed(() => {
      const uspsTranslation = translate('pdp_careplan_banner_usps');

      const usps = uspsTranslation
        .split(' * ')
        .map((usp) => {
          const label = usp.match(/\(.*?\)/g)?.[0]?.slice(1, -1) ?? '';
          const url = usp.match(/\[.*?\]/g)?.[0]?.slice(1, -1) ?? '';
          return { label, url };
        })
        .filter((usp) => usp.label && usp.url);

      return usps;
    });

    const mobileDisplayedUspIndex = ref(
      (props.position - IMAGE_BANNERS_COUNT - 1) % usps.value.length
    );

    return {
      bannerType,
      usps,
      mobileDisplayedUspIndex,
      PLP_BANNER_TYPES
    };
  }
});
